




































































































































































import Vue from 'vue'
import mixins from 'vue-typed-mixins'

import DepressionMixin from '../DepressionMixin'

const suitableImages = [
  require('@/assets/img/bild-b.png'),
  require('@/assets/img/bild-g.png'),
  require('@/assets/img/bild-h.png'),
  require('@/assets/img/bild-c.png'),
]

export default mixins(DepressionMixin).extend({
  computed: {
    image() {
      return suitableImages[(this.letter as number) % 4]
    },
  },
  props: {
    letter: {
      required: true,
      type: Number,
    },
  },
})
